import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { SubscribeModal } from './SubscribeModal';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();

    // If we're not on the home page, navigate there first
    if (!isHomePage) {
      navigate(`/#${sectionId}`);
      // The HomePage component will handle scrolling when it detects the hash
      return;
    }

    // If we're on the home page, just scroll
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="flex justify-between items-center" data-id="element-297">
          <div className="flex items-center" data-id="element-298">
            <Logo data-id="element-299" />
          </div>
          <nav className="hidden md:flex items-center space-x-8" data-id="element-300">
            {[{
            name: 'About',
            href: 'about-section'
          }, {
            name: 'Insights',
            href: 'insights'
          }, {
            name: 'Products',
            href: 'products'
          }, {
            name: 'Growth',
            href: 'growth'
          }, {
            name: 'Consulting',
            href: 'consulting'
          }].map(item => <a key={item.name} href={`#${item.href}`} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" onClick={e => scrollToSection(e, item.href)} data-id="element-301">
                {item.name}
              </a>)}
          </nav>
          <div className="flex items-center" data-id="element-302">
            <button className="px-5 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-all hover:shadow-md" onClick={() => setIsModalOpen(true)} data-id="element-303">
              Subscribe
            </button>
          </div>
        </div>
      </div>
      <SubscribeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-304" />
    </header>;
};